export default __webpack_public_path__ + "static/media/Wristwraps of the Precursor.6047baf0.jpg";